/**
 * Mejoras de Mobile solo para ch-swatch-talles
 * Detecta scroll en swatches de tallas
 */

(function() {
  'use strict';

  function initSwatchScrollDetection() {
    // Solo detectar scroll en swatches de tallas
    const swatchContainers = document.querySelectorAll('.swatch-container');
    
    swatchContainers.forEach(container => {
      function checkScroll() {
        const isScrollable = container.scrollWidth > container.clientWidth;
        // Solo para referencia interna, no agregamos clase que cause estilos
      }

      checkScroll();
      window.addEventListener('resize', checkScroll, { passive: true });
      container.addEventListener('scroll', checkScroll, { passive: true });
    });
  }

  // Inicializar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchScrollDetection);
  } else {
    initSwatchScrollDetection();
  }

  // Reinicializar cuando se carguen nuevos productos (AJAX)
  document.addEventListener('shopify:section:load', initSwatchScrollDetection);
})();

